import React,{Fragment} from "react";
import ReplyTemplate from "./ReplyTemplate";
import {
    getFormInformation,
    getSessionValue, handleErrorResponse,
    populateCurrentFormDetail,
    randstr, showToast
} from "../../Common/Appcommon";
import requestApi from "../../services/requestApi.service";

class QuickReplyOperations extends React.Component{

    leadFormname = getSessionValue('leadformname');
    formname = process.env.REACT_APP_QUICKREPLY_FORMNAME;

    constructor(props) {
        super(props);

        const type = props.type || `quick-reply`;

        this.state = {
            showModal : props.showActionModal,
            quickReplyId : props.quickReplyId,
            leadFormDetail : [],
            replyTemplateInfo : {},
            type : type,
            popupShow : false
        }
    }

    async componentDidMount() {
        let { leadFormDetail, quickReplyId, replyTemplateInfo } = this.state;
        leadFormDetail = await populateCurrentFormDetail(this.props,leadFormDetail,this.leadFormname);
        if(this.props.type !== "waNotification" && this.props.type !== "workflowAction") {
            let formResponse = await getFormInformation(quickReplyId, this.formname);
            if (formResponse.issuccess) {
                replyTemplateInfo = formResponse.data;
            } else if (formResponse.errormsg !== "") {
                showToast(formResponse.errormsg, "top-right", "error");
            }
        } else {
            replyTemplateInfo = this.props.notificationFormData;
        }
        this.setState({ leadFormDetail, replyTemplateInfo, popupShow : !this.state.popupShow });
    }

    onQuickReplySave = async (data) => {

        let { quickReplyId, type } = this.state;
        if(type === "waNotification" || type === "workflowAction"){
            this.props.toggleActionsModal(false, data);
            return;
        }
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "FORMINPUT" : data,
            "isOtherApiReq" : true,
            "FORMNAME" : this.formname,
            "TYPE" : type
        }

        let isUpdate = false;

        if(quickReplyId !== undefined && quickReplyId !== '' && quickReplyId !== null){
            params['OPERATION'] = 'UPDATE_QUICKREPLY';
            params['FORMID'] = quickReplyId;
            isUpdate = true;
        }else{
            params['OPERATION'] = 'CREATE_QUICKREPLY';
        }

        let label = 'Quick Reply';

        if(type === 'auto-reply'){
            label = 'Chat Bot';
        }else if(type === 'optin_message' || type === 'optout_message'){
            label = type;
        }else if(type === 'inboxSettings'){
            label = 'Inbox Settings';
        } else if (type === "waNotification"){
            label = 'Notification Message';
        } else if (type === "workflowAction"){
            label = 'Send Whatsapp Message';
        }

        let res = await requestApi.processServerRequest(params,"WebV2","post");
        if(res.issuccess){
            quickReplyId = res.data[0];
            if(type !== 'auto-reply'){
                if(params['OPERATION'] === 'CREATE_QUICKREPLY'){
                    showToast(`${label} created successfully`);
                }else{
                    showToast(`${label} updated successfully`);
                }
            }
        }else{
            handleErrorResponse(res.errormsg);
        }

        this.props.toggleActionsModal(false,quickReplyId,true,isUpdate);
    }

    onQuickReplyCancel = () => {
        this.props.toggleActionsModal(false);
    }

    render() {

        let { showModal, quickReplyId, leadFormDetail, replyTemplateInfo, type } = this.state;
        let {waOptions, waTemplates} = this.props;
        if(waOptions === undefined){
            waOptions = {};
        }
        if(waTemplates === undefined){
            waTemplates = {};
        }
        return (
            <Fragment>
                {this.state.popupShow &&
                <ReplyTemplate
                    key={randstr(`quickreply_template`)}
                    showModal={showModal}
                    formId={quickReplyId}
                    onSave={this.onQuickReplySave}
                    oncancel={this.onQuickReplyCancel}
                    leadFormDetail={leadFormDetail}
                    replyTemplateId={quickReplyId}
                    replyTemplateData={replyTemplateInfo}
                    type={type}
                    waOptions={waOptions}
                    waTemplates={waTemplates}
                    useForm={this.props.useForm}
                    previewData={this.props.previewData !== undefined ? this.props.previewData : {}}
                />
                }
            </Fragment>
        );
    }

}

export default QuickReplyOperations;
